import { DEFAULT_BRANDING_COLORS } from './defaults'
import { DEFAULT_BRANDING_FONT_FAMILY, resolveStoredFontFamily } from './fonts'
import { normalizeBrandingColors } from './normalizeBrandingColors'
import type { BrandingConfigurationType, EffectiveBranding } from './types'

export type { EffectiveBranding }

type StoredBrandingConfiguration = Partial<BrandingConfigurationType> | null | undefined

export const resolveEffectiveBranding = (stored: StoredBrandingConfiguration): EffectiveBranding => {
  const enabled = stored?.whiteLabelEnabled === true
  const hideMaluBranding = enabled && stored?.hideMaluBranding === true

  if (!enabled) {
    return {
      enabled: false,
      hideMaluBranding: false,
      fontFamily: DEFAULT_BRANDING_FONT_FAMILY,
      accentColor: DEFAULT_BRANDING_COLORS.accentColor,
      headerBackground: DEFAULT_BRANDING_COLORS.headerBackgroundColor,
      footerBackground: DEFAULT_BRANDING_COLORS.footerBackgroundColor,
      pageBackground: DEFAULT_BRANDING_COLORS.pageBackgroundColor,
      button: DEFAULT_BRANDING_COLORS.buttonColor,
      footerText: DEFAULT_BRANDING_COLORS.footerTextColor,
      footerTextHover: DEFAULT_BRANDING_COLORS.footerTextHoverColor,
      buttonText: DEFAULT_BRANDING_COLORS.buttonTextColor,
      timerChipBackground: DEFAULT_BRANDING_COLORS.timerChipBackgroundColor,
      timerChipText: DEFAULT_BRANDING_COLORS.timerChipTextColor,
      highlightChipBackground: DEFAULT_BRANDING_COLORS.highlightChipBackgroundColor,
      highlightChipText: DEFAULT_BRANDING_COLORS.highlightChipTextColor,
    }
  }

  const colors = normalizeBrandingColors(stored ?? undefined)

  return {
    enabled: true,
    hideMaluBranding,
    fontFamily: resolveStoredFontFamily(stored),
    accentColor: colors.accentColor,
    headerBackground: colors.headerBackgroundColor,
    footerBackground: colors.footerBackgroundColor,
    pageBackground: colors.pageBackgroundColor,
    button: colors.buttonColor,
    footerText: colors.footerTextColor,
    footerTextHover: colors.footerTextHoverColor,
    buttonText: colors.buttonTextColor,
    timerChipBackground: colors.timerChipBackgroundColor,
    timerChipText: colors.timerChipTextColor,
    highlightChipBackground: colors.highlightChipBackgroundColor,
    highlightChipText: colors.highlightChipTextColor,
  }
}
